const mfeRoutes = {
  CHANGE_PIN: '/account-services/change-pin',
  ACCOUNT_DETAILS: '/account-details',
  CARD_ACTIVATION: '/account-services/card-activation'
}

const routes = {
  ACCOUNT_SERVICES: '/account-services',
  ACTIVITY: '/activity',
  ALERTS: '/alerts',
  CALLBACK: '/callback',
  CREDIT_BALANCE_REFUND: '/refund',
  CREDIT_SCORE: '/credit-score',
  CREDIT_VIEW_ERROR: '/credit-view-error',
  CREDIT_VIEW: '/credit-view',
  DISPUTES: '/activity/disputes',
  DOCUMENT_CENTER: '/document-center',
  ERROR: '/error',
  HOME: '/',
  LOGOUT: '/logout',
  LWS_ERROR: '/lws-error',
  MARKETING_PRIVACY: '/marketing-privacy',
  PROFILE: '/profile',
  PROMOTIONS: '/promotions',
  REWARDS_ERROR: '/rewards-error',
  REWARDS: '/rewards',
  STATEMENTS: '/statements',
  ...mfeRoutes
} as const

type Valueof<T> = T[keyof T]

export type Routes = Valueof<typeof routes>

export type RouteKeys = keyof typeof routes

export type RoutesType = typeof routes

export default routes
